import { render, staticRenderFns } from "./playerModal.vue?vue&type=template&id=784b4970&scoped=true"
import script from "./playerModal.vue?vue&type=script&lang=js"
export * from "./playerModal.vue?vue&type=script&lang=js"
import style0 from "./playerModal.vue?vue&type=style&index=0&id=784b4970&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784b4970",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('784b4970')) {
      api.createRecord('784b4970', component.options)
    } else {
      api.reload('784b4970', component.options)
    }
    module.hot.accept("./playerModal.vue?vue&type=template&id=784b4970&scoped=true", function () {
      api.rerender('784b4970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traceback/videoManage/playerModal.vue"
export default component.exports